import * as XLSX from 'xlsx';

import { ReportTableService } from '@qality/common-components';
import {
  Report,
  ReportFetchResult,
  ReportFetchResultData,
} from '@qality/common-model';
import { FlagService } from '@qality/common-service';

import { getFileName } from './XLSXExporter.util';

const MAX_RESPONSE_SIZE = 10000;

export default {
  export: async (
    report: Report,
    filters: { [key: string]: string }
  ): Promise<void> => {
    const response: ReportFetchResult = await report.fetch(
      0,
      filters,
      MAX_RESPONSE_SIZE
    );

    const reportData = response.data;

    if (reportData.rows.totalElements > MAX_RESPONSE_SIZE) {
      FlagService.createControlledFlag(
        'Data incomplete',
        'Please change your filters to fit your test case executions in 1000 pages.',
        'warning',
        20000
      );
    }

    const headers = getHeaders(report);
    // get raw properties to string value mapper
    const mapper = ReportTableService.getMapper(headers, false);

    const rows = createRows(
      reportData,
      headers.map((header) => header.name),
      mapper
    );

    createXLSXfile(rows);
  },
};

function getHeaders(report: Report) {
  return report
    .getColumnNames()
    .filter((header) => header.type !== 'RELATIVE_LINK');
}

function createRows(
  reportData: ReportFetchResultData,
  headers: Array<string>,
  mapper: Array<(property: unknown) => string>
) {
  // export only headers if there is no data
  if (reportData.rows.content.length === 0) {
    return [
      Object.fromEntries(
        headers.map((header) => {
          return [header, ''];
        })
      ),
    ];
  }

  // export headers with data rows
  return reportData.rows.content.map((row) => {
    return Object.fromEntries(
      headers.map((header, index) => {
        return [header, mapper[index](row[index])];
      })
    );
  });
}

function createXLSXfile(rows: Array<{ [key: string]: string }>) {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(rows);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Summary');
  XLSX.writeFile(workbook, getFileName('Test Execution Report'));
}
